import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { storableError } from '../../util/errors';
import { denormalisedResponseEntities } from '../../util/data';
export const ASSET_NAME = 'landing-page';
const PAGE_SIZE = 12;

//================== Async Thunks =============//

////////////////////
// Fetch Featured Products //
////////////////////
const featureProductCreator = (_, { extra: sdk, rejectWithValue }) => {
  const handleError = e => {
    return rejectWithValue(storableError(e));
  };

  const handleSuccess = resp => {
    const entities = denormalisedResponseEntities(resp);
    return entities;
  };

  const request = sdk.listings.query({
    meta_featuredProduct: true,
    pub_isRfq: false,
    perPage: PAGE_SIZE,
    include: ['images'],
    'fields.listing': ['id', 'title', 'publicData.brandPhoto', 'metadata'],
    'limit.images': 1,
  });

  return request.then(handleSuccess).catch(handleError);
};

export const featuredProductThunk = createAsyncThunk(
  'LandingPage/featuredProduct',
  featureProductCreator
);

// Backward compatible wrapper function for initiateOrder
export const fetchFeaturedProduct = () => dispatch => {
  return dispatch(featuredProductThunk());
};

////////////////////
// Fetch Featured Services //
////////////////////
const featureServiceCreator = (_, { extra: sdk, rejectWithValue }) => {
  const handleError = e => {
    return rejectWithValue(storableError(e));
  };

  const handleSuccess = resp => {
    const entities = denormalisedResponseEntities(resp);
    return entities;
  };

  const request = sdk.listings.query({
    meta_featuredService: true,
    pub_isRfq: false,
    perPage: PAGE_SIZE,
    include: ['images'],
    'fields.listing': ['id', 'title', 'publicData.brandPhoto', 'metadata'],
    'limit.images': 1,
  });

  return request.then(handleSuccess).catch(handleError);
};

export const featuredServiceThunk = createAsyncThunk(
  'LandingPage/featuredService',
  featureServiceCreator
);

// Backward compatible wrapper function for initiateOrder
export const fetchFeaturedService = () => dispatch => {
  return dispatch(featuredServiceThunk());
};

// ================ Slice ================ //
const initialState = {
  featuredProductLoading: false,
  featuredProducts: [],
  featureProductError: null,
  featuredServiceLoading: false,
  featuredServices: [],
  featureServiceError: null,
};

const landingPageSlice = createSlice({
  name: 'LandingPage',
  initialState: initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(featuredProductThunk.pending, state => {
        state.featuredProductLoading = true;
        state.featureProductError = null;
      })
      .addCase(featuredProductThunk.fulfilled, (state, action) => {
        state.featuredProductLoading = false;
        state.featuredProducts = action.payload;
      })
      .addCase(featuredProductThunk.rejected, (state, action) => {
        console.error(action.payload || action.error); // eslint-disable-line
        state.featuredProductLoading = false;
        state.featureProductError = action.payload;
      })
      .addCase(featuredServiceThunk.pending, state => {
        state.featuredServiceLoading = true;
        state.featureServiceError = null;
      })
      .addCase(featuredServiceThunk.fulfilled, (state, action) => {
        state.featuredServiceLoading = false;
        state.featuredServices = action.payload;
      })
      .addCase(featuredServiceThunk.rejected, (state, action) => {
        console.error(action.payload || action.error); // eslint-disable-line
        state.featuredServiceLoading = false;
        state.featureServiceError = action.payload;
      });
  },
});

export default landingPageSlice.reducer;

export const loadData = (params, search) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  return Promise.all([
    dispatch(fetchPageAssets(pageAsset, true)),
    dispatch(fetchFeaturedProduct()),
    dispatch(fetchFeaturedService()),
  ]);
};
